import { Link } from "react-router-dom";
import { Linkedin, Instagram, ShieldCheck, MapPin } from "lucide-react";
import { usePublicConfig, publicConfigUrl } from "../../lib/usePublicConfig";
import { FlagsBENL } from "../Flags";

export default function Footer() {
  const cfg = usePublicConfig();
  const logoUrl = publicConfigUrl(cfg.logo_footer_url);
  return (
    <footer
      data-testid="oc-footer"
      className="bg-[#003B82] text-white"
    >
      <div className="oc-container py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 font-display font-bold text-xl text-white">
              {logoUrl ? (
                <img src={logoUrl} alt="OfferteExpert" className="h-9 w-auto max-w-[200px]" />
              ) : (
                <>
                  <ShieldCheck className="w-6 h-6 text-white/90" strokeWidth={2.2} />
                  <span className="text-white">OfferteExpert</span>
                </>
              )}
            </Link>
            <p className="mt-4 text-white/70 text-[15px] leading-relaxed">
              Weet wat eerlijk is. Betaal wat eerlijk is. Slimme offerte-analyse voor België en Nederland.
            </p>
            <div className="mt-5 inline-flex items-center gap-2.5 px-3 py-1.5 rounded-full bg-white/10 backdrop-blur-md border border-white/15 text-[12px] font-semibold text-white/90">
              <FlagsBENL size="sm" />
              <span>Actief in <span className="text-white">België</span> &amp; <span className="text-white">Nederland</span></span>
            </div>
            <div className="mt-6 flex gap-3">
              <a
                href="https://www.linkedin.com/"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-[13px] font-semibold uppercase tracking-[0.05em] text-white/60 mb-4">
              Platform
            </h4>
            <ul className="space-y-2.5 text-[15px]">
              <li><Link className="text-white/85 hover:text-white" to="/hoe-werkt-het">Hoe werkt het</Link></li>
              <li><Link className="text-white/85 hover:text-white" to="/prijzen">Prijzen</Link></li>
              <li><Link className="text-white/85 hover:text-white" to="/faq">FAQ</Link></li>
              <li><Link className="text-white/85 hover:text-white" to="/blog">Blog</Link></li>
              <li><Link className="text-white/85 hover:text-white" to="/contact">Contact</Link></li>
              <li><Link className="text-white/85 hover:text-white" to="/voor-bedrijven">Voor bedrijven</Link></li>
              <li>
                <Link
                  className="text-white/85 hover:text-white inline-flex items-center gap-1.5"
                  to="/sitemap"
                  data-testid="footer-sitemap-link"
                >
                  <MapPin className="w-3.5 h-3.5" /> Sitemap
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-[13px] font-semibold uppercase tracking-[0.05em] text-white/60 mb-4">
              Juridisch
            </h4>
            <ul className="space-y-2.5 text-[15px]">
              <li><Link className="text-white/85 hover:text-white" to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link className="text-white/85 hover:text-white" to="/algemene-voorwaarden">Algemene Voorwaarden</Link></li>
              <li><Link className="text-white/85 hover:text-white" to="/cookiebeleid">Cookiebeleid</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[13px] font-semibold uppercase tracking-[0.05em] text-white/60 mb-4">
              Bedrijf
            </h4>
            <p className="text-white/85 text-[15px] leading-relaxed">
              Webtron BV<br />
              A. Rodenbachwijk 12<br />
              9792 Waregem, België<br />
              BTW BE0793944703<br />
              <a className="hover:text-white underline-offset-2 hover:underline" href="mailto:info@offerteexpert.be">info@offerteexpert.be</a>
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row justify-between gap-4 text-[13px] text-white/60">
          <p>© {new Date().getFullYear()} OfferteExpert — Een product van Webtron BV. Alle rechten voorbehouden.</p>
          <div className="flex gap-5">
            <Link to="/sitemap" className="hover:text-white inline-flex items-center gap-1">Sitemap</Link>
            <Link to="/privacy-policy" className="hover:text-white">Privacy</Link>
            <Link to="/algemene-voorwaarden" className="hover:text-white">Voorwaarden</Link>
            <Link to="/cookiebeleid" className="hover:text-white">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
